/**
 * Many Realms — UTM + Microsoft Clarity Funnel Tracker
 *
 * Place this file in your Shopify theme's /assets/ folder as:
 *   manyrealms-utm-clarity-tracker.js
 *
 * Then add this line to theme.liquid just before </body>:
 *   {{ 'manyrealms-utm-clarity-tracker.js' | asset_url | script_tag }}
 *
 * For purchase tracking, paste the PURCHASE SCRIPT section separately
 * into Shopify Admin > Settings > Checkout > Order status page > Additional scripts
 *
 * Sources tracked: bgg, reddit, discord, instagram, facebook, youtube, email, internal
 * Mediums tracked: referral, social, sponsorship, email, paid, cpc
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'mr_utm';

  var STAGES = {
    LANDING:   'landing',
    COLLECTION:'collection_view',
    PRODUCT:   'product_view',
    CART:      'cart_view',
    CHECKOUT:  'checkout_start',
    PURCHASE:  'purchase'
  };

  function getUTMsFromURL() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source:   params.get('utm_source')   || null,
      utm_medium:   params.get('utm_medium')   || null,
      utm_campaign: params.get('utm_campaign') || null,
      utm_term:     params.get('utm_term')     || null,
      utm_content:  params.get('utm_content')  || null
    };
  }

  function loadStoredUTMs() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveUTMs(utms) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
    } catch (e) {}
  }

  function resolveUTMs() {
    var fromURL = getUTMsFromURL();
    var hasURLParams = fromURL.utm_source || fromURL.utm_medium || fromURL.utm_campaign;
    if (hasURLParams) {
      saveUTMs(fromURL);
      return fromURL;
    }
    return loadStoredUTMs();
  }

  function tagClarity(utms, stage) {
    if (typeof clarity !== 'function') return;
    if (utms) {
      if (utms.utm_source)   clarity('set', 'utm_source',   utms.utm_source);
      if (utms.utm_medium)   clarity('set', 'utm_medium',   utms.utm_medium);
      if (utms.utm_campaign) clarity('set', 'utm_campaign', utms.utm_campaign);
      if (utms.utm_term)     clarity('set', 'utm_term',     utms.utm_term);
      if (utms.utm_content)  clarity('set', 'utm_content',  utms.utm_content);
      var medium = utms.utm_medium || '';
      var trafficType = 'organic';
      if (['paid', 'cpc'].indexOf(medium) !== -1)       trafficType = 'paid';
      else if (medium === 'social')                      trafficType = 'social';
      else if (medium === 'referral')                    trafficType = 'referral';
      else if (medium === 'sponsorship')                 trafficType = 'sponsorship';
      else if (medium === 'email')                       trafficType = 'email';
      clarity('set', 'traffic_type', trafficType);
    } else {
      clarity('set', 'traffic_type', 'organic');
    }
    if (stage) clarity('set', 'funnel_stage', stage);
  }

  function detectPageStage() {
    var path = window.location.pathname;
    if (path === '/' || path === '')             return STAGES.LANDING;
    if (path.indexOf('/collections') === 0)      return STAGES.COLLECTION;
    if (path.indexOf('/products') === 0)         return STAGES.PRODUCT;
    if (path.indexOf('/cart') === 0)             return STAGES.CART;
    if (path.indexOf('/checkout') === 0)         return STAGES.CHECKOUT;
    var fromURL = getUTMsFromURL();
    if (fromURL.utm_source)                      return STAGES.LANDING;
    return null;
  }

  function watchCartAdd(utms) {
    document.addEventListener('cart:add', function () {
      tagClarity(utms, 'add_to_cart');
    });
    var originalFetch = window.fetch;
    window.fetch = function (url, options) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        tagClarity(utms, 'add_to_cart');
      }
      return originalFetch.apply(this, arguments);
    };
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (url && url.indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          tagClarity(utms, 'add_to_cart');
        });
      }
      return originalOpen.apply(this, arguments);
    };
  }

  function watchCheckoutClick(utms) {
    document.addEventListener('click', function (e) {
      var el = e.target;
      while (el && el !== document) {
        var href = el.getAttribute('href') || '';
        var name = (el.getAttribute('name') || '').toLowerCase();
        if (
          href.indexOf('/checkout') !== -1 ||
          name === 'checkout' ||
          (el.tagName === 'BUTTON' && el.getAttribute('type') === 'submit' && el.closest('[action*="checkout"]'))
        ) {
          tagClarity(utms, STAGES.CHECKOUT);
          break;
        }
        el = el.parentNode;
      }
    });
  }

  function init() {
    var utms = resolveUTMs();
    var stage = detectPageStage();
    var attempts = 0;
    var maxAttempts = 20;
    function tryTag() {
      if (typeof clarity === 'function') {
        tagClarity(utms, stage);
        watchCartAdd(utms);
        watchCheckoutClick(utms);
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryTag, 100);
      }
    }
    tryTag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE SCRIPT — paste this into:
// Shopify Admin > Settings > Checkout > Order status page > Additional scripts
// ═══════════════════════════════════════════════════════════════════════════════
/*

<script>
(function() {
  var STORAGE_KEY = 'mr_utm';
  function loadStoredUTMs() {
    try { var raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : null; } catch(e) { return null; }
  }
  function tagPurchase() {
    if (typeof clarity !== 'function') return;
    var utms = loadStoredUTMs();
    if (utms) {
      if (utms.utm_source)   clarity('set', 'utm_source',   utms.utm_source);
      if (utms.utm_medium)   clarity('set', 'utm_medium',   utms.utm_medium);
      if (utms.utm_campaign) clarity('set', 'utm_campaign', utms.utm_campaign);
      if (utms.utm_term)     clarity('set', 'utm_term',     utms.utm_term);
      if (utms.utm_content)  clarity('set', 'utm_content',  utms.utm_content);
    }
    clarity('set', 'funnel_stage', 'purchase');
    clarity('set', 'traffic_type', utms ? (utms.utm_medium || 'unknown') : 'organic');
    try { localStorage.removeItem('mr_utm'); } catch(e) {}
  }
  var attempts = 0;
  function tryTag() {
    if (typeof clarity === 'function') { tagPurchase(); }
    else if (attempts < 30) { attempts++; setTimeout(tryTag, 200); }
  }
  tryTag();
})();
</script>

*/